import { render, staticRenderFns } from "./ServiceDetailTabsAdditionalOptions.vue?vue&type=template&id=5da6a160&scoped=true&"
import script from "./ServiceDetailTabsAdditionalOptions.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailTabsAdditionalOptions.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailTabsAdditionalOptions.vue?vue&type=style&index=0&id=5da6a160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da6a160",
  null
  
)

export default component.exports